export const INDEX_PAGE_SIZES = [15, 50, 100, 500];
export const INDEX_PAGE_SIZE = 50;

export const normalizeIndexPagination = (searchParams: URLSearchParams) => {
  const next = new URLSearchParams(searchParams);
  const rawSize = next.get('perPage');
  if (
    rawSize !== null &&
    !INDEX_PAGE_SIZES.some(size => String(size) === rawSize)
  ) {
    next.set('page', '1');
    next.set('perPage', String(INDEX_PAGE_SIZE));
  }
  const page = Number(next.get('page') ?? 1);
  if (!Number.isSafeInteger(page) || page < 1) {
    next.set('page', '1');
  }
  return next;
};

export const getIndexPagination = (searchParams: URLSearchParams) => {
  const normalized = normalizeIndexPagination(searchParams);
  return {
    page: Number(normalized.get('page') ?? 1),
    pageSize: Number(normalized.get('perPage') ?? INDEX_PAGE_SIZE),
  };
};

export const getIndexPaginationSearchParams = (
  searchParams: URLSearchParams,
  page: number,
  pageSize: number
) => {
  const next = new URLSearchParams(searchParams);
  next.set('page', String(page));
  next.set('perPage', String(pageSize));
  return normalizeIndexPagination(next);
};
